import React from 'react'

import { graphql } from 'react-apollo'

export default \
class ModalState extends React.Component
  constructor: (props)->
    super arguments...
    @state =
      open: props.open or false

  toggle: (evt)=>
    evt?.target?.blur?()
    @setState open: not @state.open

  componentDidUpdate: =>
    @setState open: true if @props.open and not @state.open

  render: ->
    @props.render open: @state.open, toggle: @toggle

#
# Usage:
#
###
  render: ->

    <ModalState render={({open, toggle})->
      [
        <button onClick={toggle}>
          open modal!
        </button>

        <Modal
          show={open}
          onHide={toggle}
        >

          <Modal.Header closeButton>
            <Modal.Title>
              My Cool Modal
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className='clearfix'>
            Awesome modal content!
          </Modal.Body>

        </Modal>
      ]
    }/>
###
